import { render, staticRenderFns } from "./ButtonBulkPublishDrafts.vue?vue&type=template&id=4893d9d2"
import script from "./ButtonBulkPublishDrafts.vue?vue&type=script&lang=ts"
export * from "./ButtonBulkPublishDrafts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports